const attributes = {
  timelineTab: "data-timeline-tab",
  timelinePane: "data-timeline-pane",
};

const selectors = {
  timeline: "[data-timeline]",
  timelineTab: `[${attributes.timelineTab}]`,
  timelinePane: `[${attributes.timelinePane}]`,
};

const handleTabClick = (activeIndex, tabs, panes) => {
  {
    tabs.forEach((tab, index) => tab.setAttribute(attributes.timelineTab, index === activeIndex));
    panes.forEach((pane, index) =>
      pane.setAttribute(attributes.timelinePane, index === activeIndex)
    );
  }
};

const initTimeline = (timeline) => {
  const tabs = timeline.querySelectorAll(selectors.timelineTab);
  const panes = timeline.querySelectorAll(selectors.timelinePane);

  tabs?.forEach((tab, activeIndex) => [
    tab.addEventListener("click", () => handleTabClick(activeIndex, tabs, panes)),
  ]);

  handleTabClick(0, tabs, panes);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const timelines = document.querySelectorAll(selectors.timeline);

    timelines?.forEach(initTimeline);
  },
  {
    once: true,
  }
);
